import Audit from '@/models/Audit'
import User, { hasRole, Role } from '@/models/User'

export default class AuditPolicy {
    viewAny(_user: User): boolean {
        return true
    }

    view(user: User, audit: Audit): boolean {
        return user.auditor?.id === audit.auditor.id
    }

    create(user: User): boolean {
        return hasRole(user, Role.AUDITOR)
    }

    update(user: User, audit: Audit): boolean {
        return user.auditor?.id === audit.auditor.id
    }

    delete(user: User, audit: Audit): boolean {
        return user.auditor?.id === audit.auditor.id
    }

    restore(_user: User, _audit: Audit): boolean {
        return false
    }

    forceDelete(_user: User, _audit: Audit): boolean {
        return false
    }
}
